import BaseModel from '../base/BaseModel.model';
export default class ScientificMagazine extends BaseModel {
    public name?: string = "";
    public date: Date|null;
    constructor(){
        super();

        this.init();
    }

    init(){ 
        this.name = "";
        this.date = null;  
    }
}